import { defineMessages } from 'react-intl'

import { USER_LIMIT } from './constants'

export const userLimitMessages = defineMessages({
  [USER_LIMIT.ONE_TIME]: {
    id: 'userLimit.oneTime',
    defaultMessage: 'One time'
  },
  [USER_LIMIT.MULTIPLE]: {
    id: 'userLimit.multiple',
    defaultMessage: 'Multiple'
  }
})
